import React, { FC } from 'react';
import { Guest } from 'shared-types/Basket';
import { useTranslations } from '@lang';

type GuestLabelProps = {
  guest: Guest;
};
export const GuestLabel: FC<GuestLabelProps> = ({ guest }) => {
  const { t } = useTranslations();
  const title = guest.title?.toLocaleLowerCase() as 'mr' | 'mrs' | 'miss' | 'ms';
  return guest && !guest.firstName && !guest.lastName ? (
    <>{guest.email}</>
  ) : (
    <>
      {title && (
        <>
          {t(`common.${title}`) + ' '}
          {guest.firstName} {guest.lastName}
        </>
      )}
    </>
  );
};
